import { render, staticRenderFns } from "./ShokurekishoPreview.vue?vue&type=template&id=b526c384"
import script from "./ShokurekishoPreview.vue?vue&type=script&lang=js"
export * from "./ShokurekishoPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports